import React, { useState } from 'react';
import { ArrowRightIcon } from 'cokitchen-icons';
import { Link } from 'react-router-dom';
import { KITCHEN_ROUTE_KEYS } from 'utils/constants';
import SetKpisSideModal from './set-kpis';
import ScreenSettingsModal from 'components/header/screen-settings-modal';
import SplitScreen from '../split-screen';

type SettingsArrayType = {
  title: string;
  link?: string;
  description: string;
  onClick?: () => void;
};
const SettingsIndex = () => {
  const [showSetKpi, setShowSetKpi] = useState(false);
  const [showScreenSettingsModal, setShowScreenSettingsModal] = useState(false);
  const [showSplitScreen, setShowSplitScreen] = useState(false);

  const openSetKpi = () => {
    setShowSetKpi(!showSetKpi);
  };
  const toggleScreenSettingsModal = () => {
    setShowScreenSettingsModal(!showScreenSettingsModal);
  };

  const toggleSplitScreenModal = () => {
    setShowSplitScreen(!showSplitScreen);
  };

  const settingsArray: SettingsArrayType[] = [
    {
      title: 'Packaging screen settings',
      description: 'Manage number of packaging screens displayed',
      link: KITCHEN_ROUTE_KEYS.PACKAGING_SCREENS
    },
    // {
    //   title: 'Screen settings',
    //   description: 'Manage number of orders displayed',
    //   onClick: toggleScreenSettingsModal
    // },
    {
      title: 'Kitchen split screen settings',
      description: 'Manage brands split between kitchen screens',
      onClick: toggleSplitScreenModal
    },
    {
      title: 'Team List',
      description: 'Manage your general team members',
      link: KITCHEN_ROUTE_KEYS.TEAM_LIST
    },
    {
      title: 'Weekly roster',
      description: 'Manage and update team members and shift arrangement',
      link: KITCHEN_ROUTE_KEYS.WEEKLY_ROSTER
    },
    {
      title: 'Set KPIs',
      description: 'Set and update targets for your team',
      onClick: openSetKpi
    },
    {
      title: 'Team of the month',
      description: 'Manage team members and shifts arrangement',
      link: KITCHEN_ROUTE_KEYS.TEAM_OF_THE_MONTH
    },
    {
      title: 'Top members of the month',
      description: 'Crown and track top performers for each month',
      link: KITCHEN_ROUTE_KEYS.TOP_MEMBERS_OF_THE_MONTH
    },
    {
      title: 'Notice board',
      description: 'Need to pass across a message to the team, do it here',
      link: KITCHEN_ROUTE_KEYS.NOTICE_BOARD
    }
  ];

  return (
    <div>
      <div>
        <h3 className='text-2xl font-semibold mb-8'>Settings</h3>
        <div className='w-full max-w-[750px] flex flex-col space-y-[20px] gap-2'>
          {settingsArray.map(({ title, description, link, onClick }, index) => (
            <Link key={index} to={link ?? ''} onClick={onClick}>
              <div className='w-full flex justify-between items-center pb-[14px] border-b-[0.7px] border-b-[#EAEBEB] cursor-pointer'>
                <div>
                  <p className='text-sm font-medium'>{title}</p>
                  <p className='text-xs text-gray-8'>{description}</p>
                </div>
                <div className='w-[30px] h-[30px] bg-[#F2F2F2] flex justify-center items-center rounded-full'>
                  <ArrowRightIcon />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
      {showSetKpi && <SetKpisSideModal show onClose={openSetKpi} />}
      {showScreenSettingsModal && <ScreenSettingsModal show onClose={toggleScreenSettingsModal} />}
      {showSplitScreen && <SplitScreen show onClose={toggleSplitScreenModal} />}
    </div>
  );
};

export default SettingsIndex;
